import type { Cart, CartItem } from '../types/cart';

const CART_STORAGE_KEY = 'trincity_cart';

export const cartStorage = {
  getCart: (): Cart => {
    try {
      const saved = localStorage.getItem(CART_STORAGE_KEY);
      if (saved) {
        const cart = JSON.parse(saved);
        // Ensure cart has proper structure
        return {
          items: cart.items || [],
          total_items: cart.total_items || 0,
          subtotal: cart.subtotal || 0,
          last_updated: cart.last_updated || new Date().toISOString(),
        };
      }
    } catch (error) {
      console.error('Failed to load cart from storage:', error);
    }
    
    // Return empty cart if nothing saved or error
    return {
      items: [],
      total_items: 0,
      subtotal: 0,
      last_updated: new Date().toISOString(),
    };
  },

  saveCart: (cart: Cart): void => {
    try {
      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
    } catch (error) {
      console.error('Failed to save cart to storage:', error);
    }
  },

  calculateTotals: (items: CartItem[]): { total_items: number; subtotal: number } => {
    const total_items = items.reduce((sum, item) => sum + item.quantity, 0);
    const subtotal = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    
    return { total_items, subtotal };
  },

  clearCart: (): void => {
    try {
      localStorage.removeItem(CART_STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear cart from storage:', error);
    }
  },
};